/**
 * @generated SignedSource<<518b433dbb4b6d735e44063d6f469929>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Image_item$data = {
  readonly description: string | null;
  readonly " $fragmentType": "Image_item";
};
export type Image_item$key = {
  readonly " $data"?: Image_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"Image_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Image_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "7837a5e64b1b2f856919a6e924b293cf";

export default node;
